<template>
    <div class="row justify-content-center">
        <div class="col-md-11">
            <div class="row fotoDerecha my-5" v-if="pos == 'fotoderecha'" data-aos="fade-up" data-aos-duration="1000">
                <div class="col-lg-7 pl-lg-5 m-0 contImagen order-lg-12">
                    <img :src="imagen" class="img-fluid" />
                </div>
                <div class="col-lg-5 text-left py-4 order-lg-1">
                    <h3 v-html="titulo"></h3>
                    <div class="texto">{{ texto }}</div>
                    <button href="#" v-scroll-to="'#tresPasos'" class="btn btn-primary">{{ textoURL }} <img src="@/assets/images/flechalinks.svg" class="flechalinks" /></button>
                </div>
            </div>
            <div class="row fotoIzquierda my-5" v-if="pos == 'fotoizquierda'" data-aos="fade-up" data-aos-duration="1000">
                <div class="col-lg-7 pr-lg-5 m-0 contImagen">
                    <img :src="imagen" class="img-fluid" />
                </div>
                <div class="col-lg-5 text-left py-4">
                    <h3 v-html="titulo"></h3>
                    <div class="texto">{{ texto }}</div>
                    <button href="#" v-scroll-to="'#tresPasos'" class="btn btn-primary">{{ textoURL }} <img src="@/assets/images/flechalinks.svg" class="flechalinks" /></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'FotoTexto',
  props: {
    titulo: String,
    texto: String,
    linkURL: String,
    textoURL: String,
    imagen: String,
    pos: String,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  font-weight: 700;
  font-size: 22px;
}
.flechalinks {
    height: 15px;
    margin-left: 10px;
}
.texto {
    padding: 20px 20px;
    font-size: 13px;
    font-weight: 400;
}
.fotoDerecha img {
    /*width: 460px;*/
}
.fotoIzquierda img {
    /*width: 460px;*/
}
.contImagen {
    position: relative;
}
.btn-primary {
    margin-top: 20px;
    background-color: #FFF !important;
    border-radius: 0;
    border: 4px solid #1900FF;
    padding: 6px 20px 6px 20px;
    color: #000;
    font-weight: 700;
    text-decoration: underline;
}
.btn-primary:hover {
    background-color: #1900FF !important;
    color: #FFF;
}
.btn-primary span {
    color: #1900FF;
    font-size: 30px;
    font-weight: 600;
    line-height: 20px;
    display: block;
    float: right;
    margin-top: 3px;
    margin-left: 20px;
}
.btn-primary:hover span {
    color: #FFF;
}
@media only screen and (max-width: 990px){
    .btn-primary {
        width: 100%;
        font-size: 14px;
        text-decoration: none;
        padding: 6px 10px 6px 10px;
    }
    h3 {
        font-size: 19px;
        margin-top: 15px;
        margin-left: 10px;
    }
    .texto {
        padding: 20px 30px;
    }
}
</style>
